<template>
  <div class="c-64">
    <div class="pd-b-50 ">
      <div class="position-fixed t-0 l-0 w-fill z-index-999 pd-b-5 bg-f">
        <van-tabs v-model="activeTab" color="#51C027" title-active-color="#51C027">
          <van-tab title="已购"></van-tab>
          <van-tab title="拼团"></van-tab>
          <!--<van-tab title="待评价" :info="waitNum"></van-tab>-->
        </van-tabs>
      </div>
      <div class="mg-t-60">
        <template v-if="activeTab === 0">
          <div class="c-app-green fs-14 pd-l-20 pd-b-15 mg-b-2" @click="onSortTypeClick">
            {{ sortType === 1 ? '按购买日期排序' : '按作者更新日期排序' }}
            <van-icon name="arrow-down"/>
          </div>
          <div v-if="orderList.length>0">
            <div v-for="order in orderList" class="mg-b-10 mg-l-10 mg-r-10 bdr-10 pd-10 bg-f"
                 @click="onOrderClick(order)">
              <div class="fs-16 text-ellipsis-2">
                <span class="text-strong" style="vertical-align: middle;">{{ order.title }}</span>
              </div>
              <div class="fs-12">
                {{ order.subjectName }}
              </div>
              <div class="fs-12 mg-t-8">
                <div v-if="order.hasOwnProperty('orderId')" class="c-app-orange flex items-center justify-between">
                  <span class="c-9 fs-12">订单号：{{ order.orderId }}</span>
                  <span class="c-app-green fs-12 cursor-pointer pd-10 cursor-pointer" @click.stop="copyOrderId(order.orderId)">复制</span>
                </div>
                <div class="c-app-orange">
                  <span class="c-9 fs-12">更新日期：{{ order.editAt }}</span>
                </div>
                <div class="c-app-orange">
                  <span class="c-9 fs-12">上次下载：{{ order.orderTime }}</span>
                </div>
              </div>
              <div style="height: 1px;background: #e1e1e1;margin-top: 20px;margin-bottom: 10px"></div>
              <div class="c-app-orange justify-content-space-between align-items-center">
                <span class="c-9 fs-12">购买日期：{{ order.orderTime }}</span>
                <div class="c-app-orange">
                  <span class="c-9 fs-12">已付：</span>
                  <template v-if="$parent.isIos && $parent.appInner">{{ order.realAmount / 100 }}资源币</template>
                  <template v-else>￥{{ order.realAmount / 100 }}</template>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-align-center mg-t-100 c-8">
            {{ loadMessage }}
          </div>
        </template>
        <template v-else-if="activeTab === 1">
          <div v-if="teamList.length>0">
            <div v-for="team in teamList" class="mg-t-10 mg-l-10 mg-r-10 bdr-10 pd-10 bg-f"
                 @click="onTeamClick(team)">
              <div class="fs-16 text-ellipsis-2">
                <span class="text-strong" style="vertical-align: middle;">{{ team.title }}</span>
              </div>
              <div class="justify-content-space-between mg-t-10 align-items-center">
                <div v-if="team.status == 9" class="fs-12  text-align-right c-app-green">
                  拼团成功
                  <span v-if="team.refundStatus==2" class="c-app-red">
                    (已退款)
                  </span>
                  <span v-if="team.refundStatus==3" class="c-app-red">
                    (退款失败)
                  </span>
                </div>
                <div v-else-if="team.status == -1" class="fs-12  text-align-right c-app-red">
                  拼团失败
                  <span v-if="team.refundStatus==2">
                    (已退款)
                  </span>
                  <span v-if="team.refundStatus==3">
                    (退款失败)
                  </span>
                </div>
                <div v-else class="fs-12  text-align-right c-9">
                  进度：<span class="c-app-green">{{ team.payCount }}</span> / <span
                    class="c-app-green">{{ team.users }}</span>
                  人
                </div>
                <div class="c-app-orange">
                  <span class="c-9 fs-12">已付：</span>
                  <template v-if="$parent.isIos && $parent.appInner">{{ team.realAmount / 100 }}资源币</template>
                  <template v-else>￥{{ team.realAmount / 100 }}</template>
                </div>
              </div>
            </div>
            <div class="fs-14 text-align-center mg-t-20 c-a">拼团成功的资源会显示在已购列表</div>
          </div>
          <div v-else class="text-align-center mg-t-100 c-8">
            暂无数据
          </div>
        </template>
        <template v-else-if="activeTab === 2">
          <div v-if="waitScoreList.length>0">
            <div v-for="order in waitScoreList" class="mg-t-10 mg-l-10 mg-r-10 bdr-10 pd-10 bg-f"
                 @click="onOrderClick(order)">
              <div class="fs-16 text-ellipsis-2">
                <span class="text-strong" style="vertical-align: middle;">{{ order.title }}</span>
              </div>
              <div class="justify-content-space-between mg-t-10 fs-12 align-items-center mg-r-10">
                <div class="fs-12 c-app-green text-align-right">
                  {{ order.subjectName }}
                </div>
              </div>
              <div style="height: 1px;background: #e1e1e1;margin-top: 20px;margin-bottom: 10px"></div>
              <div class="c-app-orange justify-content-space-between align-items-center">
                <span class="c-9 fs-12">购买日期：{{ order.orderTime }}</span>
                <div class="c-app-orange">
                  <span class="c-9 fs-12">已付：</span>
                  <template v-if="$parent.isIos && $parent.appInner">{{ order.realAmount / 100 }}资源币</template>
                  <template v-else>￥{{ order.realAmount / 100 }}</template>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-align-center mg-t-100 c-8">
            暂无数据
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../libs/api.request'

export default {
  name: "purchased",
  data() {
    return {
      activeTab: 0,
      orderList: [],
      teamList: [],
      waitScoreList: [],
      waitNum: '',
      test: '',
      sortType: 1, //1按下单日期 2按更新日期
      loadMessage: '暂无数据'
    }
  },
  methods: {
    getPurchasedList() {
      this.loadMessage = '加载中';
      request.request({
        url: 'order/getPurchasedList?sortType=' + this.sortType,
      }).then((data) => {
        this.orderList = data.orderList;
        if (this.orderList.length === 0) {
          this.loadMessage = '暂无数据';
        }
        this.teamList = data.teamList;
        this.waitScoreList = data.waitScoreList;
        if (this.waitScoreList.length > 0) {
          this.waitNum = this.waitScoreList.length;
        }
      }).catch(e => {
        this.loadMessage = '获取失败';
      })
    },
    onSortTypeClick() {
      this.sortType = this.sortType === 0 ? 1 : 0;
      this.orderList = [];
      this.getPurchasedList();
    },
    onOrderClick(order) {
      this.$router.push({path: '/card/' + order.cardId})
    },
    onTeamClick(team) {
      this.$router.push({path: '/team/' + team.teamId})
    },
    copyOrderId(orderId) {
      const input = document.createElement('input');
      input.value = orderId;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast('订单号已复制');
    }
  },
  watch: {
    '$route'(to, from) {
      if (from.path === '/') {
        this.getPurchasedList();
      }
    }
  },
  mounted() {
    this.getPurchasedList();
  }
}
</script>

<style>
.van-info {
  right: -5px !important;
  /*background-color: #EC901D !important;*/
}

body {
  background: #f4f4f4;
}

</style>
